import { componentSizeMap } from '@pit-element-plus/constants'

import type { ComponentSize } from '@pit-element-plus/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
